export const INTEGRATIONS = {
  pageTitle: 'Integrations',
  callout:
    'Integration configuration is coming soon. Contact PolyAI for integration support',
  filterToggleButton: {
    activeFilters: (activeFilters: number) => `${activeFilters} active filters`,
    filterToggleText: 'Filter integrations',
  },
  emptyState: {
    title: 'No integrations match your search and filters',
    text: 'Try adjusting your spelling or selected filters',
  },
  filterOptions: {
    telephony: 'Telephony',
    crm: 'CRM',
    knowledgeBase: 'Knowledge Base',
    hospitality: 'Hospitality',
    healthcare: 'Healthcare',
    chat: 'Chat',
  },
  forms: {
    telephoneErrorMessage:
      'Please enter a valid phone number with country code (e.g. +441234567890)',
    formErrorMessage: 'Please fix the errors in the form before proceeding',
    stepConfigurationNotFoundMessage: 'Step configuration not found',
  },
  environmentTab: {
    connectionDetails: {
      connectedLabel: 'Connected',
      configurationTitle: 'Configuration',
      configurationDescription:
        'If this connection is used by other environments, your changes will also take effect there.',
    },
    connectForm: {
      useExistingConnectionLabel: 'Use existing connection',
      connectNewAccount: 'Connect new account',
      connectTo: (name: string) => `Connect to ${name}`,
    },
    metadataValues: {
      yes: 'Yes',
      no: 'No',
    },
  },
  modals: {
    disconnect: {
      title: (integrationName: string) =>
        `Are you sure you want to disconnect ${integrationName}?`,
      description: (integrationName: string) =>
        `This action will remove all ${integrationName} data from your project.`,
      button: {
        cancel: 'Cancel',
        confirm: 'Disconnect',
      },
    },
    connectWarning: {
      title: (integrationName: string) =>
        `Are you sure you want to connect to ${integrationName}?`,
      description: (activeIntegrations: string, integrationCategory: string) =>
        `You are currently connected to ${activeIntegrations} other integrations. Please be aware that simultaneous ${integrationCategory} integrations are not recommended. Would you like to proceed?`,
      button: {
        cancel: 'Cancel',
        confirm: 'Proceed',
      },
    },
    restricted: {
      title: 'Integration Restricted',
      description: (integrationName: string) => (
        <>
          <strong>{integrationName}</strong> is not available on demo accounts.
        </>
      ),
      upgradeMessage:
        'Upgrade to an Enterprise plan or speak to the PolyAI team to gain access to this integration.',
      button: {
        close: 'Close',
        contact: 'Contact PolyAI Team',
      },
    },
    handoffWarning: {
      title: 'Update handoff configuration',
      content:
        'Please make sure to update your handoff configuration to ensure your integration is working correctly.',
      primaryButton: 'Take me there',
      secondaryButton: 'Dismiss',
    },
  },
};
